// Team role vocabulary (security-teams §2.2). Canonical values are stored in
// team_members.role; the UI shows friendly labels (Manager / Read & write /
// Read-only). Power order mirrors internal/access: viewer < member <
// maintainer < owner. Pure module — node-unit-testable.

export type Role = "owner" | "maintainer" | "member" | "viewer";

/** ROLES lists every role, most powerful first (select-option order). */
export const ROLES: Role[] = ["owner", "maintainer", "member", "viewer"];

export const ROLE_LABELS: Record<Role, string> = {
  owner: "Owner",
  maintainer: "Manager",
  member: "Read & write",
  viewer: "Read-only",
};

const POWER: Record<Role, number> = { viewer: 1, member: 2, maintainer: 3, owner: 4 };

/** roleAtLeast reports whether role is at least as powerful as min. */
export function roleAtLeast(role: Role | null, min: Role): boolean {
  if (!role) return false;
  return POWER[role] >= POWER[min];
}

/**
 * assignableRoles returns the roles myRole may grant or take away: maintainers
 * manage everyone below owner; owners manage all (mirrors CanManageMembers).
 */
export function assignableRoles(myRole: Role | null): Role[] {
  if (myRole === "owner") return ROLES;
  if (myRole === "maintainer") return ROLES.filter((r) => r !== "owner");
  return [];
}
